export default __webpack_public_path__ + "blank-webhook.bb6d57c1407ac06befe0.svg";